import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import KeycloakContext from "../../keycloakContext";
import {
  canAccessClassicSurvey,
  canAccessJourney,
  canAccessJourneyEntry,
  canAccessStudentDashboard,
  canAccessTeacherArea,
  getDefaultRouteForRole,
  getUserRoleFromKeycloak,
  hasAnyRole,
} from "../utils/accessPolicy";

const ACCESS_CHECKS = {
  classicSurvey: canAccessClassicSurvey,
  journey: canAccessJourney,
  journeyEntry: canAccessJourneyEntry,
  teacherArea: canAccessTeacherArea,
  studentDashboard: canAccessStudentDashboard,
};

const ProtectedRoute = ({ children, roles, access }) => {
  const keycloak = useContext(KeycloakContext);

  if (!keycloak) {
    return <div>Loading Keycloak...</div>;
  }

  if (!keycloak.authenticated) {
    keycloak.login();
    return null;
  }

  const role = getUserRoleFromKeycloak(keycloak);
  const fallbackRoute = getDefaultRouteForRole(role);

  if (roles && roles.length > 0 && !hasAnyRole(role, roles)) {
    return <Navigate to={fallbackRoute} replace />;
  }

  if (access) {
    const accessCheck = ACCESS_CHECKS[access];
    if (typeof accessCheck === "function" && !accessCheck(role)) {
      return <Navigate to={fallbackRoute} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
